import {
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
} from '@mui/icons-material';

export const getFileIcon = (_fileName: string, fileType?: string) => {
  if (fileType?.startsWith('image/')) {
    return <ImageIcon fontSize="small" />;
  }
  if (fileType === 'application/pdf') {
    return <PdfIcon fontSize="small" />;
  }
  return <FileIcon fontSize="small" />;
};

export const formatFileSize = (sizeBytes?: number): string => {
  if (!sizeBytes) return '';

  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${(sizeBytes / 1024).toFixed(1)} KB`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
};
